"use client";

import { c as _c } from "react/compiler-runtime";
import { getDefaultProfileSettingsChainIcon, getDefaultProfileSettingsHideWalletWorth, getDefaultProfileSettingsRarity, PROFILE_SETTINGS_CHAIN_ICON_NAME, PROFILE_SETTINGS_NET_WORTH_NAME, PROFILE_SETTINGS_RARITY_COOKIE_NAME } from "@opensea/navigation/profile-settings";
import { useCookie } from "@opensea/ui-kit/hooks";
import { createContext } from "use-context-selector";
export const ProfileSettingsContext = createContext({
  hideWalletWorth: false,
  setHideWalletWorth: () => undefined,
  showRarity: true,
  setShowRarity: () => undefined,
  showChainIcon: false,
  setShowChainIcon: () => undefined
});
export function ProfileSettingsProvider(t0) {
  const $ = _c(16);
  const {
    children
  } = t0;
  const [profileSettingsHideWalletWorth, setProfileSettingsHideWalletWorthCookie] = useCookie(PROFILE_SETTINGS_NET_WORTH_NAME);
  const [profileSettingsRarity, setProfileSettingsRarityCookie] = useCookie(PROFILE_SETTINGS_RARITY_COOKIE_NAME);
  const [profileSettingsChainIcon, setProfileSettingsChainIconCookie] = useCookie(PROFILE_SETTINGS_CHAIN_ICON_NAME);
  const t1 = profileSettingsHideWalletWorth ? profileSettingsHideWalletWorth === "true" : getDefaultProfileSettingsHideWalletWorth() === "true";
  let t2;
  if ($[0] !== setProfileSettingsHideWalletWorthCookie) {
    t2 = showLogos => setProfileSettingsHideWalletWorthCookie(showLogos.toString());
    $[0] = setProfileSettingsHideWalletWorthCookie;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = profileSettingsRarity ? profileSettingsRarity === "true" : getDefaultProfileSettingsRarity() === "true";
  let t4;
  if ($[2] !== setProfileSettingsRarityCookie) {
    t4 = showRarity => setProfileSettingsRarityCookie(showRarity.toString());
    $[2] = setProfileSettingsRarityCookie;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = profileSettingsChainIcon ? profileSettingsChainIcon === "true" : getDefaultProfileSettingsChainIcon() === "true";
  let t6;
  if ($[4] !== setProfileSettingsChainIconCookie) {
    t6 = showChainIcon => setProfileSettingsChainIconCookie(showChainIcon.toString());
    $[4] = setProfileSettingsChainIconCookie;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = {
      hideWalletWorth: t1,
      setHideWalletWorth: t2,
      showRarity: t3,
      setShowRarity: t4,
      showChainIcon: t5,
      setShowChainIcon: t6
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const value = t7;
  let t8;
  if ($[13] !== children || $[14] !== value) {
    t8 = <ProfileSettingsContext.Provider value={value}>{children}</ProfileSettingsContext.Provider>;
    $[13] = children;
    $[14] = value;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}